<div *ngIf="active">
	<ng-content *ngIf="!template"></ng-content>
	<ng-container *ngIf="template" [ngTemplateOutlet]="template"> </ng-container>
</div>
